
ko.bindingHandlers.tippy = {
    init: function (element, valueAccessor, allBindingsAccessor,) {

        if (!('tippy' in window)) {
            console.error('tooltip library tippy is not defined!')
        }
        const subscriptions: Array<KnockoutSubscription> = [];
        const bindingOptionsOrValue = ko.utils.unwrapObservable(valueAccessor());
        const userOptions = allBindingsAccessor().tippyOptions ?? {};
        const tippyOptions = {};

        let tip = null;

        //special properties can be observable:

        if ('theme' in userOptions && ko.isObservable(userOptions.theme)) {

            const obs: KnockoutObservable<string> = userOptions.theme;      //store observable
            userOptions.theme = ko.unwrap(obs)  //unwrap observable

            subscriptions.push(obs.subscribe((value) => {
                tip?.setProps({
                    theme: value
                })
            }));
        }

        //geen object, of anders null (null is oke, dat wordt later mogelijk text)
        if (typeof bindingOptionsOrValue !== 'object' ||
            bindingOptionsOrValue === null) {

            //global options
            ko.utils.extend(tippyOptions, ko.bindingHandlers.tippy.textOptions)
            //user options
            ko.utils.extend(tippyOptions, userOptions)

            tippyOptions.content = bindingOptionsOrValue;

            delete tippyOptions.showOnChange;

            tip = tippy(element, tippyOptions)

            ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
                //cleanup
                tip.destroy();
                subscriptions.forEach(sub => sub.dispose())
            });
        }
    },
    update: function (element, valueAccessor, allBindingsAccessor) {

        const bindingOptions = ko.utils.unwrapObservable(valueAccessor());
        const userOptions = allBindingsAccessor().tippyOptions ?? {};
        const tippyOptions = {};

        const tip = element._tippy;
        let component = null



        if (bindingOptions !== null &&
            typeof bindingOptions === 'object' &&
            'component' in bindingOptions) {

            ko.components.get(bindingOptions.component, function (_component) {
                component = _component;
            })

            //global options
            Object.assign(tippyOptions, ko.bindingHandlers.tippy.componentOptions);

         
            Object.assign(tippyOptions, userOptions);

            //mandatory options:
            Object.assign(tippyOptions, {
                onShow: function (instance) {
                    tippy.hideAll({ exclude: instance, duration: 0 });

                    //geen throw, alleen warning aan devs
                    if (!component)
                        console.warn(`Could not get component with ${JSON.stringify(bindingOptions.component)}.`)


                    //TODO; figure out how to extend binding context with $component
                    //this is not really working with the component-technique of knockout, but rather put the viewmodel and model together by ourselves
                    //startpoint: https://knockoutjs.com/documentation/custom-bindings-controlling-descendant-bindings.html

                    //load the component ourselves:
                    const content = instance.popper.querySelector('.tippy-content')

                    //content.innerHTML = component.template[0].outerHTML;
                    ko.cleanNode(content)
                    DOM.cleanNode(content)
                    content.innerHTML = '';

                    component.template.forEach(function (i) {
                        content.appendChild(
                            i.cloneNode(true))
                    })

                    const formFactor = di`Formfactor`;

                    if (formFactor === 'phone') {

                        const htmlNode = document.createRange().
                            createContextualFragment(
                                ko.bindingHandlers.tippy.closeUI);

                        content.appendChild(htmlNode);
                        //to prevent clicking a menu-item on start
                        content.style.pointerEvents = 'none';
                    }

                    //content.style.padding = '10px';
                    //content.style.position = 'relative';

                    const params = ko.unwrap(valueAccessor()).params;

                    const viewModel = ('createViewModel' in component) ?
                        component.createViewModel(params) :
                        params;

                    viewModel.$tippy = instance;
                    viewModel.$htmlElement = content;

                    ko.applyBindings(viewModel, content);

                    setTimeout(() => {
                        content.style.pointerEvents = 'auto';
                    }, 200)

                    // setTimeout(function () { dict.scanForTags(content) }, 50)
                },
                onHidden: function (instance) {
                    //$('.dashboard-main').css('filter', 'none')

                    var content = instance.popper.querySelector('.tippy-content')

                    ko.cleanNode(content);

                }
            });

            tippy(element, tippyOptions);

        } else {

            const value = ko.utils.unwrapObservable(valueAccessor());
            const userOptions = allBindingsAccessor().tippyOptions ?? {};

            if (!tip) {
                console.warn(element);
            }

            if (!value)
                tip.hide();

            tip.setContent(value);

            if (userOptions.showOnChange && value)
                tip.show();




        }
    },
    componentOptions: {
        ignoreAttributes:true,
        arrow: true,
        theme: 'light',  /*error, warning, dark, light-border, light. material-light*/
        maxWidth: '1200px',
        touch: ['hold', 0],
        inertia: true,
        interactiveBorder: 15,
        interactive: true,
        delay: [250, 150],
        placement: 'right',
        popperOptions: {
            strategy: 'absolute',
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        clippingParents: 'none',
                        rootBoundary: 'viewport',
                        altAxis: true,
                    }
                }
            ]
            //]
        },
    },
    textOptions: {
        ignoreAttributes:true,
        onShow: (instance) => {
            //to distinct text and component tooltips
            instance.popper.setAttribute('text',true)
            //instance.popper.attributes['text'] = true;
            //do not show when content empty 
            if (!instance.props.content)
                return false;
        },
        touch: ['hold', 500],
        popperOptions: {
            placement: 'bottom-end'
        }
    },
    closeUI: `<button
                style="position:fixed;bottom: 5px;right: 5px;"
                class="btn btn-default"
                onclick="tippy.hideAll()">{{dict('Close')}}</button>`
};

tippy.defaultProps.touch = ['hold', 500];